import { DateTime } from "luxon";

/** The bits of a facility simulator the Go live choice needs. */
export interface GoLiveSimulatorInput {
  id: string;
  name: string;
  status?: {
    currentAdKit?: {
      id: string | null;
      name?: string | null;
      isClubhouseAdKit?: boolean;
    } | null;
    agConnect?: { connected?: boolean; lastActivityTime?: string };
  };
}

export interface SimulatorChoice {
  id: string;
  name: string;
  isOnline: boolean;
  /** "Last seen 3 hours ago" for an offline sim, when the API knows. */
  lastSeen: string | null;
  /** What going live here does: "Replaces Fall Sponsors" / "No ads right now". */
  effect: string;
}

function lastSeenText(iso: string | undefined, now: DateTime): string | null {
  if (!iso) return null;
  const when = DateTime.fromISO(iso);
  if (!when.isValid) return null;
  return `Last seen ${when.toRelative({ base: now }) ?? when.toFormat("MMM d")}`;
}

export function buildSimulatorChoices(
  simulators: GoLiveSimulatorInput[],
  now: DateTime = DateTime.now(),
): SimulatorChoice[] {
  return simulators.map((sim) => {
    const current = sim.status?.currentAdKit;
    const isOnline = sim.status?.agConnect?.connected ?? false;
    const effect = !current?.id
      ? "No ads right now"
      : current.isClubhouseAdKit === false
        ? "Replaces ads set up on this sim"
        : `Replaces ${current.name ?? "the campaign that's live"}`;
    return {
      id: sim.id,
      name: sim.name,
      isOnline,
      lastSeen: isOnline
        ? null
        : lastSeenText(sim.status?.agConnect?.lastActivityTime, now),
      effect,
    };
  });
}
